export const INTERACTION_EVENT_OPEN = 'open'
export const INTERACTION_EVENT_VIEW = 'view'

export type InteractionEvent = typeof INTERACTION_EVENT_OPEN | typeof INTERACTION_EVENT_VIEW
